import React from 'react'
import ContentfulJsonLdBlocks from 'src/components/shared/ContentfulJsonLdBlocks'
import { createClient } from 'contentful-management-11'
import Layout from 'src/components/layouts'
import TestimonialsPage from 'src/components/pages/BrandPages/Testimonials'
import logger from 'src/common/logger'
import { getMegamenuData } from 'src/common/back/megamenu'
import { getContentfulJsonLd } from 'src/common/getContentfulJsonLd'
import SiteConfigService from 'src/services/SiteConfigService'

const parseResourceUrn = (urn) => {
  const re =
    /^crn:contentful:::content:spaces\/([^/]+)\/environments\/([^/]+)\/entries\/([^/]+)$/
  const m = urn.match(re)
  if (!m) throw new Error(`Unrecognized URN: ${urn}`)
  const [, spaceId, environmentId, entryId] = m

  return { spaceId, environmentId, entryId }
}

const resolveResourceLink = async (link) => {
  if (!link?.sys?.urn) throw new Error('Not a ResourceLink.')
  const { spaceId, environmentId, entryId } = parseResourceUrn(link.sys.urn)
  const remoteClient = createClient(
    { accessToken: process.env.CONTENTFUL_MANAGEMENT_ACCESS_TOKEN || '' },
    { type: 'plain', defaults: { spaceId, environmentId } }
  )

  return remoteClient.entry.get({ entryId })
}

export async function getServerSideProps(context) {
  const jsonLdSchemas = await getContentfulJsonLd('testimonials/')

  let megamenuData = null
  let reviewsRes = null

  try {
    const siteConfigResponse =
      await SiteConfigService.getInstance().getByFieldName('trustMarkers')
    const jsonContents = siteConfigResponse?.[0]?.jsonContent || []
    const results = await Promise.all(
      jsonContents.map((item) => resolveResourceLink(item))
    )
    const reviewsEntry = results.find(
      (item) => item?.fields?.fieldName?.['en-US'] === 'ReviewsSectionArray'
    )
    reviewsRes = reviewsEntry?.fields?.jsonContent?.['en-US'] || null
    megamenuData = await getMegamenuData(context)
  } catch (error) {
    logger.error('testimonials page: failed to get trustpilot data', { error })
  }

  const reviews = (reviewsRes?.reviews || []).map((item) => ({
    ...item,
    text: item?.review || '',
    consumer: {
      displayName: item?.fullName || '',
      displayLocation: item?.location || '',
    },
  }))

  return {
    props: {
      jsonLdSchemas,
      reviews: reviews || [],
      megamenuData: megamenuData || null,
    },
  }
}

const Testimonials = ({ reviews, megamenuData, jsonLdSchemas }) => {
  return (
    <>
      <ContentfulJsonLdBlocks jsonLdSchemas={jsonLdSchemas} />
      <Layout
        isBrandPage={true}
        footerClassName="mb-5 lg:mb-0"
        dashboardClass="bg-blue-300 text-white"
        megamenuData={megamenuData}
      >
        <TestimonialsPage data={{ reviews }} />
      </Layout>
    </>
  )
}

export default Testimonials
